import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import AuthTenantPageError from '../../../pages/error/AuthTenantPageError';
import { fail_tenant_retrieve_brand_stock_age_category_data, loading_tenant_retrieve_brand_stock_age_category_data, reset_tenant_retrieve_brand_stock_age_category_data, success_tenant_retrieve_brand_stock_age_category_data } from '../../../reducers/auth_tenant/tenant_retrieve_brand_stock_age_category_data_Slice';
import { COULD_NOT_RETRIEVE_STOCK_AGE_ANALYSIS_BRAND_ANALYSIS_DATA_ERROR_MSG, COULD_NOT_RETRIEVE_STOCK_AGE_ANALYSIS_BRAND_ANALYSIS_DATA_SUCCESS_MSG } from '../../../utils/error_success_messages';
import { RETRIEVE_TENANT_SPECIFIC_PRODUCT_CATEGORY_STOCK_AGE_ANALYSIS_DATA_API } from '../../../api/api_data';
import { addThreeDots, formatNumber, formatToSentenceCase, messageToast } from '../../../utils/Utils';
import * as app_consts from "../../../utils/app_consts";
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import AuthTenantLoader from '../../../pages/loaders/AuthTenantLoader';
import { Block, Button, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent } from '../../Component';
import CardTabs from '../../../pages/components/cards/CardTabs';
import ListText from '../../../pages/components/text/ListText';
import moment from 'moment';
import ViewBrandStockAgeProductBreakDownModal from './ViewBrandStockAgeProductBreakDownModal';
import { download, generateCsv, mkConfig } from 'export-to-csv';

const ViewBrandStockAgeAnalysisModal = ({ tenant_info, user_info, isOpen, successFunction, closeModal, data }) => {

  const [open, setOpen] = useState(isOpen);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  const [sent_data, setSentData] = useState(data);
  const [page_data, setPageData] = useState([]);
  const [activeCardTab, setActiveCardTab] = useState("Main Details");
  const [participantItemsPerPage] = useState(50);
  const [currentParticipantItemsPage, setCurrentParticipantPage] = useState(1);
  const [initiate_promotion_draw_modal, setInitiatePromotionDrawModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(10);
  const [sm, updateSm] = useState(false);

  const [view_product_modal, setViewProductModal] = useState(false);
  const [selected_product, setSelectedProduct] = useState('');

  const open_view_product_modal = (r_data) => {
    setViewProductModal(true);
    setSelectedProduct(r_data);
  };

  const close_view_product_modal = () => {
    setViewProductModal(false);
    setSelectedProduct('');
  };

  const view_product_modal_successFunction = () => {
    successFunction();
    retrieve_data(sent_data);
  };

  // Card Tabs
  const tabs = [
    {
      tabName: "Main Details"
    },
    {
      tabName: "Products"
    }
  ];

  useEffect(() => {
    setError("");
    setSentData(data);
    setOpen(isOpen);


    if (isOpen && data)
    {
      retrieve_data(data);
    }
  }, [isOpen, data]);

  const retrieve_data = (id) => {
    setError("");
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_tenant_retrieve_brand_stock_age_category_data, success_tenant_retrieve_brand_stock_age_category_data, fail_tenant_retrieve_brand_stock_age_category_data, COULD_NOT_RETRIEVE_STOCK_AGE_ANALYSIS_BRAND_ANALYSIS_DATA_ERROR_MSG, COULD_NOT_RETRIEVE_STOCK_AGE_ANALYSIS_BRAND_ANALYSIS_DATA_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_SPECIFIC_PRODUCT_CATEGORY_STOCK_AGE_ANALYSIS_DATA_API}/${id}`));
  };

  const tenant_retrieve_brand_stock_age_category_data_listner = useSelector((state) => state.tenant_retrieve_brand_stock_age_category_data.tenant_retrieve_brand_stock_age_category_data);

  useEffect(() => {
    if (tenant_retrieve_brand_stock_age_category_data_listner.status !== app_consts.IDLE)
    {
      if (tenant_retrieve_brand_stock_age_category_data_listner.status === app_consts.LOADING && !page_data)
      {
        setLoading(true);
        setError("");
      } else
      {
        setLoading(false);
        if (tenant_retrieve_brand_stock_age_category_data_listner.status === app_consts.FAIL && !page_data)
        {
          setError(tenant_retrieve_brand_stock_age_category_data_listner.message);
          messageToast(tenant_retrieve_brand_stock_age_category_data_listner.message, app_consts.FAIL);
        } else if (tenant_retrieve_brand_stock_age_category_data_listner.status === app_consts.SUCCESS)
        {
          setPageData(tenant_retrieve_brand_stock_age_category_data_listner.data);
          console.log(tenant_retrieve_brand_stock_age_category_data_listner.data?.product_stock_age_analysis_by_category);
        }
        dispatch(reset_tenant_retrieve_brand_stock_age_category_data());
      }
    }
  }, [tenant_retrieve_brand_stock_age_category_data_listner]);

  // Pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = page_data?.product_stock_age_analysis_by_category?.slice(indexOfFirstItem, indexOfLastItem);

  // Save page to localStorage
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const export_to_csv = async (e) => {
    e.preventDefault();
    const cur_dt = moment().format("DD-MM-YYYY h:mm:ss a");

    // Headers
    const csv_headers = ["Brand", "Product ID", "Product Name", "Product Type", "Current Balance", "Average Age Days", "Last Added At", "Last Subtracted At"];

    const csv_data = page_data?.product_stock_age_analysis_by_category?.map((item) => {
      return {
        brand: page_data?.category_stock_age_data?.category,
        product_id: item?.product_id,
        product_name: item?.product_name,
        product_type: item?.product_type,
        average_age_days: formatNumber(item?.average_age_days),
        current_balance: item?.balance,
        last_added_at: item?.last_added_at ? moment(item?.last_added_at).format("YYYY-MM-DD HH:mm:ss") : "--",
        last_subtracted_at: item?.last_subtracted_at ? moment(item?.last_subtracted_at).format("YYYY-MM-DD HH:mm:ss") : "--"
      };
    });

    const options = mkConfig({
      fieldSeparator: ',',
      quoteStrings: '"',
      showLabels: true,
      showTitle: false,
      title: " ",
      useTextFile: false,
      useBom: true,
      filename: `Stock Age by Brand on ${cur_dt}`,
      useKeysAsHeaders: true,
      columnHeaders: csv_headers,
    });

    const csv = generateCsv(options)(csv_data || []);

    download(options)(csv);

  };


  return (
    <>
      < Modal isOpen={open} className="modal-dialog-centered" size={"xl"}  >
        <ModalHeader toggle={!(loading) ? () => {
          successFunction();
          closeModal();
        } : undefined}>Brand Stock Age Brand Analysis Details</ModalHeader>
        <ModalBody>
          {
            loading ?
              <>
                <AuthTenantLoader tenant_info={tenant_info} loading_message="Retrieveing Brand Stock Age Analysis Details..." />
              </>
              :
              <>
                {
                  error ?
                    <>
                      <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
                    </>
                    :
                    <>
                      <Block>
                        <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />
                      </Block>
                      <div className="card-inner bg-white">
                        {
                          activeCardTab === "Main Details" && (
                            <>
                              <div className="profile-ud-list">
                                <div className="profile-ud-item">
                                  <div className="profile-ud wider">
                                    <span className="profile-ud-label">Brand</span>
                                    <span className="profile-ud-value">{page_data?.category_stock_age_data?.category || "--"}</span>
                                  </div>
                                </div>
                                <div className="profile-ud-item">
                                  <div className="profile-ud wider">
                                    <span className="profile-ud-label">Average Age Days</span>
                                    <span className="profile-ud-value">{page_data?.category_stock_age_data?.average_age_days ? formatNumber(page_data?.category_stock_age_data?.average_age_days || 0) : "--"}</span>
                                  </div>
                                </div>
                                <div className="profile-ud-item">
                                  <div className="profile-ud wider">
                                    <span className="profile-ud-label">Number of Products</span>
                                    <span className="profile-ud-value">{page_data?.products_no || "--"}</span>
                                  </div>
                                </div>
                                <div className="profile-ud-item">
                                  <div className="profile-ud wider">
                                    <span className="profile-ud-label">Total Number of Units</span>
                                    <span className="profile-ud-value">{page_data?.overall_balance || "--"}</span>
                                  </div>
                                </div>
                                <div className="profile-ud-item">
                                  <div className="profile-ud wider">
                                    <span className="profile-ud-label">Last Product Added Date</span>
                                    <span className="profile-ud-value">{page_data?.last_movement_dates_by_category?.last_added_at ? moment(page_data?.last_movement_dates_by_category?.last_added_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                  </div>
                                </div>
                                <div className="profile-ud-item">
                                  <div className="profile-ud wider">
                                    <span className="profile-ud-label">Last Product Subtracted Date</span>
                                    <span className="profile-ud-value">{page_data?.last_movement_dates_by_category?.last_subtracted_at ? moment(page_data?.last_movement_dates_by_category?.last_subtracted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                  </div>
                                </div>
                              </div>
                            </>
                          )
                        }
                        {
                          activeCardTab === "Products" && (
                            <>
                              <Block>
                                <div className="d-flex justify-content-end mb-3">
                                  <Button
                                    color="primary"
                                    className="btn-primary"
                                    onClick={export_to_csv}
                                  >
                                    <Icon name="download-cloud" />
                                    <span>Export to CSV</span>
                                  </Button>
                                </div>
                                <div className="nk-tb-list is-separate is-medium mb-3">
                                  <DataTableHead className="nk-tb-item">
                                    <DataTableRow><span className="sub-text">Product Name</span></DataTableRow>
                                    <DataTableRow><span className="sub-text">Product Type</span></DataTableRow>
                                    <DataTableRow><span className="sub-text">Last Added Date</span></DataTableRow>
                                    <DataTableRow><span className="sub-text">Last Subtracted Date</span></DataTableRow>
                                    <DataTableRow><span className="sub-text">Current Balance</span></DataTableRow>
                                    <DataTableRow size="lg"><span className="sub-text">Average Age Days</span></DataTableRow>
                                    <DataTableRow><span className="sub-text">Action</span></DataTableRow>
                                  </DataTableHead>
                                  {currentItems.length > 0 &&
                                    currentItems.map((item) => (
                                      <DataTableItem key={item.id}>
                                        <DataTableRow>
                                          <div className="user-card">
                                            <div className="user-info">
                                              <span className="tb-lead">
                                                {item?.product_name?.replace(/_/g, " ").toUpperCase() || "--"}
                                              </span>
                                            </div>
                                          </div>
                                        </DataTableRow>
                                        <DataTableRow>
                                          <span className="tb-lead">{item?.product_type?.replace(/_/g, " ").toUpperCase() || "--"}</span>
                                        </DataTableRow>
                                        <DataTableRow>
                                          <span className="tb-lead">{item?.last_added_at ? moment(item?.last_added_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                        </DataTableRow>
                                        <DataTableRow>
                                          <span className="tb-lead">{item?.last_subtracted_at ? moment(item?.last_subtracted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                        </DataTableRow>
                                        <DataTableRow>
                                          <span className="tb-lead">{item?.balance ? item?.balance : "--"}</span>
                                        </DataTableRow>
                                        <DataTableRow>
                                          <span className="tb-lead">{item?.average_age_days ? formatNumber(item?.average_age_days || 0) : "--"}</span>
                                        </DataTableRow>
                                        <DataTableRow>
                                          <Button color="primary" size="sm" className="btn btn-dim" onClick={() => open_view_product_modal(item?.product_id)}>
                                            View
                                          </Button>
                                        </DataTableRow>
                                      </DataTableItem>
                                    ))}
                                </div>
                                {currentItems.length > 0 && (
                                  <div className="mt-3">
                                    <PaginationComponent
                                      itemPerPage={itemPerPage}
                                      totalItems={page_data?.product_stock_age_analysis_by_category?.length}
                                      paginate={paginate}
                                      currentPage={currentPage}
                                    />
                                  </div>
                                )}
                              </Block>

                              <ViewBrandStockAgeProductBreakDownModal tenant_info={tenant_info} user_info={user_info} isOpen={view_product_modal} successFunction={view_product_modal_successFunction} closeModal={close_view_product_modal} data={selected_product} />
                            </>
                          )
                        }
                      </div>
                    </>
                }
              </>
          }
        </ModalBody>
      </Modal>
    </>
  );
};

export default ViewBrandStockAgeAnalysisModal;